import { render, staticRenderFns } from "./contactForm.vue?vue&type=template&id=a2d01238&scoped=true&"
import script from "./contactForm.vue?vue&type=script&lang=ts&"
export * from "./contactForm.vue?vue&type=script&lang=ts&"
import style0 from "./contactForm.vue?vue&type=style&index=0&id=a2d01238&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d01238",
  null
  
)

export default component.exports